import React from 'react';
import { Container, ContainerGutter, styled } from '@volkswagen-onehub/components-core';
import CarDetail from './CarDetail';
import { VehicleData } from '../../types';

export const CarDetailsContainer = styled.div`
    @media screen and (min-width: 1040px) {
		grid-row: 3 / span 1;
	}
`;

export interface CardetailsInterface {
    vehicle : VehicleData;
}

export default ({ vehicle }: CardetailsInterface) => {
    return (
        <CarDetailsContainer>
            <Container
                wrap="always"
                gutter={ContainerGutter.static500}>

                    {vehicle && <CarDetail vehicle={vehicle} />}

            </Container>
        </CarDetailsContainer>
    );
}
